import { Button } from '@mui/material';
import { styled } from '@mui/material/styles';

export const Content = styled('main')`
  padding: var(--spacing-small);
  padding-bottom: 0;
  width: var(--preference-popover-label-width-desktop);
`;

export const Footer = styled('footer')`
  display: flex;
  justify-content: flex-end;
  padding: var(--spacing-medium);
`;

export const CreateLabelButton = styled(Button)(() => ({
  '&[aria-expanded="true"]': {
    backgroundColor: 'var(--color-grey-light)',
  },
  paddingInline: 'var(--spacing-medium)',
}));
